module.exports = __webpack_public_path__ + "static/ktykogm-41ce0c23d2c1d055fb0a6de3fdbc422c.jpg";